import React from 'react';
import CustomerList from '../components/customers/CustomerList';

const Customers = () => {
  return <CustomerList />;
};

export default Customers;